// extracted by mini-css-extract-plugin
export default {"container":"Statistic_container__bAqpU","statContainer":"Statistic_statContainer__xUeFf","singleStat":"Statistic_singleStat__s6-BG"};